@if (optionGroup$) {
  <motn-popover-multi-select
    [multiOrSingle]="multiOrSingle"
    [optionGroup$]="optionGroup$"
    [inputPlaceholder]="'Device Name or ID'"
    (clickedOutsideMenu$)="clickedOutsideMenu$.emit()"
    (clickedOption$)="onSelectDevice($event)"
    [overlayPositions]="overlayPositions"
  ></motn-popover-multi-select>
}
